import ContactForm from '../components/ContactForm';

function Home({ t, lang }) {
  return (
    <main className="page-container bg-custom">
      <div className='container text-center'>
        <h1 className='page-title'>CONTACT</h1>  
      <ContactForm t={t} lang={lang} />
      </div>
    </main>
  );
}

export default Home;